import { render, staticRenderFns } from "./ChooseYourBoxType.vue?vue&type=template&id=a77205fa&scoped=true&"
import script from "./ChooseYourBoxType.vue?vue&type=script&lang=js&"
export * from "./ChooseYourBoxType.vue?vue&type=script&lang=js&"
import style0 from "./ChooseYourBoxType.vue?vue&type=style&index=0&id=a77205fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77205fa",
  null
  
)

export default component.exports